import { Box, HStack, Text } from '@chakra-ui/react';

import { getPercentileColor } from './chart-utils';

/** Percentile gradient bar showing the user's position on a red-yellow-green scale. */
export const PercentileBar = ({ percentile }: { percentile: number }) => (
  <Box>
    <HStack justify="space-between" mb={1}>
      <Text fontSize="xs" color="gray.400">
        0th
      </Text>
      <Text fontSize="xs" color="gray.500" fontWeight="semibold">
        Your Percentile: {percentile}th
      </Text>
      <Text fontSize="xs" color="gray.400">
        100th
      </Text>
    </HStack>
    <Box position="relative" h="10px" borderRadius="full" overflow="hidden">
      <Box
        h="100%"
        borderRadius="full"
        bg="linear-gradient(90deg, #E53E3E 0%, #DD6B20 20%, #D69E2E 40%, #38A169 70%, #276749 100%)"
      />
      {/* Thumb indicator */}
      <Box
        position="absolute"
        top="-2px"
        left={`${percentile}%`}
        transform="translateX(-50%)"
        w="14px"
        h="14px"
        borderRadius="full"
        bg="white"
        border="3px solid"
        borderColor={getPercentileColor(percentile)}
        boxShadow="sm"
      />
    </Box>
  </Box>
);
